export const font = {
  primary: '"Fellix", sans-serif',
  secondary: '"FraktionMono", sans-serif',
  weight: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
};
